import React, { useState, useEffect } from 'react'
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DoneIcon from '@mui/icons-material/Done';
import { SaveUploadFileDocDetails } from '../../../NewAdminDesign/Community/AddEditDealer/DealerActioncreator';


export default function EditPersonalDetail({ data, closePopup, customStyle, handleLoader, handleTextPopup, closeTextPopup, allDocuments,admin }) {
    const [objectData, setObjectData] = useState({});

    const handleInputValues = (e, objs) => {
        const { files } = e.target;
        const obj = {
            fileName: files[0]?.name,
            file: files[0],
            ApiData: objs
        }
        setObjectData(obj)
        handleSave(obj)
    }




    const handleSave = (obj) => {
        let multipartFormData = new FormData();
        multipartFormData.append("fileName", obj?.ApiData?.documentName);
        multipartFormData.append("file", obj?.file);
        multipartFormData.append("documentId", obj?.ApiData?.documentId);
        multipartFormData.append("type", getFileExt(obj.fileName));
        multipartFormData.append("userId", data?.userId);
        multipartFormData.append("replaceOrUpload", checkReplaceOrUpload(obj.ApiData));
        multipartFormData.append("formStatus", "update");
        multipartFormData.append("empId", admin?.emailId);

        handleLoader(true)

        SaveUploadFileDocDetails(multipartFormData, (callback) => {
            handleLoader(false)
            console.log(callback)
            setObjectData({})
            if (callback == "success") {
                handleTextPopup(true, "Document Uploaded Successfully")
            } else {
                handleTextPopup(true, "Error Uploading Document")
            }
            closeTextPopup()

        })
    }

    const getFileExt = (fileName) => {
        const lastDotIndex = fileName.lastIndexOf(".");
        const extension = lastDotIndex !== -1 ? fileName.slice(lastDotIndex + 1).toLowerCase() : "";
        const fE = extension == "pdf" ? "pdf" : extension == "png" || extension == "jpg" || extension == "jpeg" ? "img" : ''
        return fE
    }

    const checkReplaceOrUpload = (value) => {
        if (value?.documentUrl !== "" && value?.documentUrl !== undefined && value?.documentUrl !== null) {
            return 1
        } else {
            return 0
        }

    }

    return (
        <>
            <div className='background-blur income' style={customStyle}>
                <div className='popup-main small-popup container-fluid dbl-border' style={{ minWidth: '70%' }}>
                    <button className='close' onClick={e => closePopup()}>
                        &times;
                    </button>
                    <h4 style={{ color: '#000' }}>Edit Document Details</h4>

                    <div className="row" style={{ maxHeight: '350px ', overflowY: 'auto' }}>
                        {
                            allDocuments && allDocuments?.length > 0 ? allDocuments?.map((value, index) => {
                                return (
                                    <>
                                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>
                                            <div>
                                                <h5 style={{ fontSize: '15px', display: 'flex', alignItems: 'center' }}>{value?.documentName || ""} &nbsp;&nbsp; {(value?.documentUrl !== "" && value?.documentUrl !== undefined && value?.documentUrl !== null) ? <DoneIcon style={{ color: 'green' }} /> : ""}</h5>
                                                <div style={{ position: 'relative', marginTop: '10px' }}>
                                                    <input type='file' style={{ position: 'absolute', inset: '0', opacity: '0' }} onChange={(e) => handleInputValues(e, value)} />
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <div style={{ margin: '0px 10px 0 0 ', display: 'inline-block', border: '1px dashed #006c67', padding: '10px 13px', borderRadius: '6px', textAlign: 'center', background: '#eee' }}>
                                                            <CloudUploadIcon style={{ fontSize: '25px' }} />
                                                        </div>
                                                        <h6 style={{ margin: '0' }}>Select File</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            })
                                : ''}

                    </div>

                </div>


            </div >
        </>
    )
}
